import { render } from "./view.vue?vue&type=template&id=50446a0a&scoped=true"
import script from "./view.vue?vue&type=script&lang=js"
export * from "./view.vue?vue&type=script&lang=js"

import "./view.vue?vue&type=style&index=0&id=50446a0a&lang=scss&scoped=true"
import "./view.vue?vue&type=style&index=1&id=50446a0a&lang=scss"

import exportComponent from "/Users/mymac/Documents/Digitala/Perki/newest-perki/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50446a0a"]])

export default __exports__